import React from 'react';
import { useFeatureFlag } from 'js/sign-components/common/feature-flag';
import { WhiteLabelingAppNew } from './white-labeling-app-new';
import { WhiteLabelingAppOld } from './white-labeling-app-old';

export const WhiteLabelingApp = () => {
  return useFeatureFlag('sign_core_2025_12_08_white_labeling_swap') ? (
    <WhiteLabelingAppNew />
  ) : (
    <WhiteLabelingAppOld />
  );
};
